<template>
  <v-footer height="auto"
            class="footer center-style"
            dark>
    <v-row flat
           tile
           :style="{background:$root.themeColor}"
           class="text-xs-center">
      <v-flex class="left-style center-style">
        <v-flex class="left-first">
          <v-row class="center-style">
            <img class="logo"
                 src="@/assets/logo.png" />
            <v-flex style="font-size: 20px !important">四川持恒空间科技有限公司</v-flex>
          </v-row>
          <v-flex class="left-first-text">{{text}}</v-flex>
          <v-btn @click="$router.push({ name: 'CompanyProfile' })"
                 class="btn-more">更多信息</v-btn>

          <v-flex class="left-second">
            <v-row class="center-style rows">
              <v-icon>fa fa-map-marker</v-icon>
              <v-flex class="icon-content">
                <v-flex class="icon-title">地址</v-flex>
                <v-flex class="icon-title-content">
                  成都市武侯大道顺江段77号吾悦广场2栋1304
                </v-flex>
              </v-flex>
            </v-row>

            <v-divider></v-divider>

            <v-row class="center-style rows">
              <v-icon class="icon-style">fa fa-phone</v-icon>
              <v-flex class="icon-content">
                <v-flex class="icon-title">电话</v-flex>
                <v-flex class="icon-title-content">028-87549100</v-flex>
              </v-flex>
            </v-row>

            <v-divider></v-divider>
            <v-row class="center-style rows">
              <v-icon>fa fa-envelope</v-icon>
              <v-flex class="icon-content">
                <v-flex class="icon-title">邮箱</v-flex>
                <v-flex class="icon-title-content">838040677@qq.com</v-flex>
              </v-flex>
            </v-row>
          </v-flex>
        </v-flex>
      </v-flex>

      <v-divider vertical></v-divider>

      <v-flex class="right-style center-style">
        <com-map :mapObj="mapObj"
                 class="map-style"></com-map>
      </v-flex>
    </v-row>

    <v-flex class="icp-style">
      <a href="https://beian.miit.gov.cn/" target="_blank">互联网ICP备案：蜀ICP备2020035623号-1</a>
    </v-flex>
  </v-footer>
</template>

<script>
export default {
  data () {
    return {
      text:
        '公司致力于自然资源行业，为测绘和信息化提供服务。',
      mapObj: {
        //查询地址
        selectWords: '成都市武侯大道顺江段77号（吾悦广场）2栋',
        //查询城市
        selectCity: '成都',
        //地图显示等级
        mapLevel: 15,
      },
    }
  },
}
</script>

<style scoped>
.text-xs-center {
  padding-top: 40px;
  padding-bottom: 50px;
}
.center-style {
  display: flex;
  justify-content: center;
  align-items: center;
}
.rows {
  margin: 5px 0 10px 0;
}
.icon-style {
  font-size: 20px !important;
}
.left-style {
  width: 50%;
  flex: none;
}
.left-first {
  width: 80%;
  flex: none;
}
.left-first-text {
  margin-top: 10px;
  font-size: 14px;
}
.logo {
  width: 50px;
}
.btn-more {
  margin-top: 20px;
  border: 1px solid white !important;
  width: 150px !important;
  height: 50px !important;
  font-size: 25px;
  background: transparent !important;
}
.left-second {
  margin-top: 20px;
}
.icon-content {
  margin-left: 40px;
}
.icon-title {
  font-size: 25px;
}
.icon-title-content {
  font-size: 14px;
  margin-top: 10px;
}
.right-style {
  width: 49%;
  flex: none;
}
.map-style {
  width: 80% !important;
  flex: none;
}
.footer {
  position: relative;
}
.icp-style {
  position: absolute;
  bottom: 10px;
}
</style>
